export default __webpack_public_path__ + "static/media/i068vp.523cac90.webp";